import { MutableRefObject } from 'react';

type ElementStyles = Partial<CSSStyleDeclaration>;

interface InitialStyles {
	container?: ElementStyles;
	labelEl?: ElementStyles;
	buttonIcon?: ElementStyles;
	buttonEl?: ElementStyles;
}

export const LABEL_EL_SELECTOR = 'div > div > div > button > div > span';
export const BUTTON_ICON_SELECTOR = 'div > div > div > button > div > svg';
export const BUTTON_EL_SELECTOR = 'div > div > div > button';
export const WIDGET_FOOTER_SELECTOR = '.chat-footer-container';

interface UpdateAssistantStylesParams {
	container: HTMLElement;
	isMapMode: boolean;
	isAdminSidebarOpen: boolean;
	initialStylesRef: MutableRefObject<InitialStyles | null>;
}

export function updateAssistantStyle({
	container,
	isMapMode,
	isAdminSidebarOpen,
	initialStylesRef,
}: UpdateAssistantStylesParams) {
	const labelEl = container.querySelector<HTMLSpanElement>(LABEL_EL_SELECTOR);
	const buttonIcon = container.querySelector<SVGElement>(BUTTON_ICON_SELECTOR);
	const buttonEl = container.querySelector<HTMLButtonElement>(BUTTON_EL_SELECTOR);

	if (isMapMode) {
		container.style.position = 'absolute';
		container.style.right = '54px';

		if (initialStylesRef.current?.container) {
			Object.assign(container.style, initialStylesRef.current.container);
		}
		if (labelEl && initialStylesRef.current?.labelEl) {
			Object.assign(labelEl.style, initialStylesRef.current.labelEl);
		}
		if (buttonIcon && initialStylesRef.current?.buttonIcon) {
			Object.assign(buttonIcon.style, initialStylesRef.current.buttonIcon);
		}
		if (buttonEl && initialStylesRef.current?.buttonEl) {
			Object.assign(buttonEl.style, initialStylesRef.current.buttonEl);
		}

		return;
	}

	Object.assign(container.style, {
		position: 'absolute',
		left: '18px',
		maxWidth: 'unset',
		width: 'fit-content',
	});

	if (!isAdminSidebarOpen) {
		container.style.left = '5px';

		if (buttonEl) {
			buttonEl.style.paddingLeft = '.75rem';
		}
		if (labelEl) {
			labelEl.style.display = 'none';
		}
		if (buttonIcon) {
			buttonIcon.style.display = 'none';
		}
	} else {
		if (labelEl && initialStylesRef.current?.labelEl) {
			Object.assign(labelEl.style, initialStylesRef.current.labelEl);
		}
		if (buttonIcon && initialStylesRef.current?.buttonIcon) {
			Object.assign(buttonIcon.style, initialStylesRef.current.buttonIcon);
		}
		if (buttonEl && initialStylesRef.current?.buttonEl) {
			Object.assign(buttonEl.style, initialStylesRef.current.buttonEl);
		}
	}
}
